export default __webpack_public_path__ + "static/media/remove.3064958e.png";